import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { size } from "@clockwise/web-commons/src/styles/type.styles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";

export const gif: CSSProperties = {
  opacity: 0.5,
};

export const caption: CSSProperties = {
  marginBottom: spacing.std,
  fontSize: size.md,
};

export const sample: CSSProperties = {
  transform: "rotate(-30deg)",
  position: "absolute",
  marginTop: 92,
  width: "100%",
  fontSize: size.xxl,
  color: greys.slate,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
